import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class HoldingTransactionsDetailsUseCase extends BaseUseCase {
    constructor(pnlTxnReportRepo) {
        super();
        this.pnlTxnReportRepo = pnlTxnReportRepo;
    }
    async fetchResult(requestData) {
        return await this.pnlTxnReportRepo.holdingTransactionDetails(requestData);
    }
}
export default HoldingTransactionsDetailsUseCase;
